import { Link as RouterLink } from 'react-router-dom';

import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import Badge from '@mui/material/Badge';
import { useTheme } from '@mui/material/styles';

import { paths } from 'src/routes/paths';
import Iconify from 'src/components/iconify';
import { useCart } from 'src/contexts/CartContext';

// ----------------------------------------------------------------------

export default function FloatingCartButton() {
  const theme = useTheme();
  const { getItemCount } = useCart();
  const itemCount = getItemCount();

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: { xs: 16, md: 24 },
        right: { xs: 16, md: 24 },
        zIndex: 999,
      }}
    >
      <Badge
        badgeContent={itemCount}
        color="error"
        sx={{
          '& .MuiBadge-badge': {
            fontSize: 14,
            fontWeight: 700,
            height: 24,
            minWidth: 24,
            padding: '0 6px',
          },
        }}
      >
        <Fab
          component={RouterLink}
          to={paths.eCommerce.cart}
          color="primary"
          size="large"
          sx={{
            boxShadow: theme.customShadows.z20,
            '&:hover': {
              boxShadow: theme.customShadows.z24,
              transform: 'scale(1.05)',
            },
            transition: 'all 0.2s ease-in-out',
          }}
        >
          <Iconify icon="solar:cart-large-minimalistic-bold" width={28} />
        </Fab>
      </Badge>
    </Box>
  );
}
